import { Goal, ShortTermGoal } from 'domains/care-plans';

export const calculateGoalProgress = (baseline: number, target: number, current: number): number => {
  if (baseline > target || !current || current < 0) {
    return 0;
  }

  const percentage = ((current - baseline) * 100) / (target - baseline);

  return Math.max(Math.min(percentage, 100), 0);
};

export const formatGoalTarget = (target: number, type: string): string => {
  if (type === 'percent') {
    return `${target}%`;
  }

  return `${target}`;
};

/**
 * Removes goals with a "discontinued" `status`.
 */
export const filterDiscontinuedGoals = (goals: Array<Goal | ShortTermGoal>): Array<Goal | ShortTermGoal> => {
  return goals
    .filter(goal => goal.goalStatus !== 'discontinued')
    .map(goal => {
      if ('shortTermGoals' in goal) {
        return { ...goal, shortTermGoals: filterDiscontinuedGoals(goal.shortTermGoals) };
      }

      return goal;
    });
};
